export const BY_CREDIT_CARD = 'accept_credit_card'
export const BILL_BY_INVOICE = 'bill_by_invoice'

export const PAYMENT_STATUS_PAID = 'paid'
export const PAYMENT_STATUS_REFUNDED = 'refunded'
export const PAYMENT_STATUS_DECLINED = 'declined'
